// extracted by mini-css-extract-plugin
module.exports = {"modal-xl":"EditProblemModal_modal-xl__3KG-5","btn_footer":"EditProblemModal_btn_footer__1-Dck","footer_message":"EditProblemModal_footer_message__1hovL"};